import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

// INITIAL STATE aka Default State
const authInitialState = {
  authState: null,
};

const userInitialState = {
  user: null, // logged in user
  users: [],
  userToUpdate: null, // used to pass user value to a modal
  userToDelete: null,
  isUsersLoading: false,
  userError: null,
};

const recipientInitialState = {
  recipients: [],
  recipient: null,
  recipToCreate: null, // used to pass recip value to a modal
  recipToDelete: null, // used to pass recip value to a modal
  totalRecips: 0,
  checkStatus: null,
  isRecipientsLoading: false,
  recipientsError: null,
};

const orgInitialState = {
  org: {}, // Org of the logged in user
  orgs: [], // list of orgs
  orgToUpdate: null, // used to pass org value to a modal
  isOrgLoading: false,
  orgError: null,
};

const duplicateInitialState = {
  duplicates: [],
  duplicate: {},
  duplicateIdsToResolve: [],
  duplicatesToResolve: [],
  isDuplicateLoading: false,
  duplicateError: null,
};

const state = {
  ...authInitialState,
  ...userInitialState,
  ...recipientInitialState,
  ...orgInitialState,
  ...duplicateInitialState,
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
})
